import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/styles.css'
import './assets/css/responsive.css'
import './assets/css/fonts.css'
import './assets/css/app.css'
import Layout from "./components/Layout";
import {
    Routes,
    Route
} from "react-router-dom";
import React, { Suspense } from "react";
import {RedirectAuth, RequireAuth} from "./utils/common";
import { ToastContainer } from 'react-toastify';
import {getAccessToken} from "./utils/authority";

// Lazy load routes for code splitting
const Home = React.lazy(() => import("./routes/home"));
const Admin = React.lazy(() => import("./routes/admin"));
const AuthSas = React.lazy(() => import("./routes/authsas"));
const DeleteAccount = React.lazy(() => import("./routes/delete-account"));
const Privacy = React.lazy(() => import("./routes/privacy"));
const NotFound = React.lazy(() => import("./routes/not-found"));

// Loading fallback component
const LoadingFallback = () => (
    <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
);
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuth: false
        }
    }
    componentDidMount() {
        let token = getAccessToken();
        this.setState({isAuth: !!token});
        if (process.env.NODE_ENV === 'development') {
            console.log("Version ReactJs", React.version);
        }
    }
    render() {
        return (
            <Layout>
                <Suspense fallback={<LoadingFallback />}>
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <RequireAuth redirectTo="/dang-nhap">
                                    <Admin />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/ad-sas-school/*"
                            element={
                                <RequireAuth redirectTo="/dang-nhap">
                                    <Admin />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/dang-nhap"
                            element={
                                <RedirectAuth redirectTo="/ad-sas-school">
                                    <AuthSas />
                                </RedirectAuth>
                            }
                        />
                        <Route path="/home/*" element={<Home/>}/>
                        <Route path="/yeu-cau-xoa-tai-khoan" element={<DeleteAccount/>}/>
                        <Route path="/privacy" element={<Privacy/>}/>
                        <Route path="*" element={<NotFound/>}/>
                    </Routes>
                </Suspense>
                <ToastContainer />
            </Layout>
        );
    }
}
export default  App;
